module.exports = __webpack_public_path__ + "img/icon-game-6365.84f44f47.png";